import axios from 'axios'
import { showSuccess, showError } from '../../index.js'
import DOMPurify from 'dompurify'

export default {
  namespaced: true,
  state () {
    return {
      questions: []
    }
  },
  mutations: {
    setQuestions (state, payload) {
      state.questions = payload
    }
  },
  getters: {
    backendQuestion (state) {
      return state.questions
    },
    getQuestion (state) {
      return state.questions.filter(item => item.isActive === true)
    }
  },
  actions: {
    async getQuestionData (context) {
      await axios.get(context.rootState.API_Url + 'Questions').then((response) => {
        const responseData = response.data.map(item => ({
          ...item,
          answer_vn: DOMPurify.sanitize(item.answer_vn),
          answer_en: DOMPurify.sanitize(item.answer_en)
        }))
        context.commit('setQuestions', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getQuestionAdminData (context) {
      await context.rootState.authAxios.get('/Questions/GetQnaAdmin').then((response) => {
        const responseData = response.data.map(item => ({
          ...item,
          answer_vn: DOMPurify.sanitize(item.answer_vn),
          answer_en: DOMPurify.sanitize(item.answer_en)
        }))
        context.commit('setQuestions', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postQuestion (context, payload) {
      await context.rootState.authAxios.post('/Questions/', payload)
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateQuestion (context, payload) {
      await context.rootState.authAxios.put(`/Questions/${payload.id}`, payload)
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteQuestion (context, payload) {
      await context.rootState.authAxios.delete(`/Questions/${payload}`)
        .then(() => {
          showSuccess('Xóa thành công')
        }).catch((error) => {
          if (error.response.data.error_message) {
            showError(error.response.data.error_message)
          } else {
            showError('Đã xảy ra lỗi không mong muốn')
          }
        })
    }
  }
}
